import { Dispatch } from 'react';

export const showApplePay = (
  flags: any,
  setShowApplePayOption: Dispatch<React.SetStateAction<boolean>>,
  showApplePayOption: boolean
) => {
  if (flags && !flags.enableApplePaySocialEcomm) {
    setShowApplePayOption(false);
    return false;
  }
  if (window.ApplePaySession && !showApplePayOption) setShowApplePayOption(true);
  return !!window.ApplePaySession;
};

export const loadApplePay = (
  applePayAvailable: any,
  setApplePayLoaded: Dispatch<React.SetStateAction<boolean>>
) => {
  if (applePayAvailable && window.ApplePaySession) {
    const merchantIdentifierRoot = document.location.hostname.split('.')[0];
    const merchantIdentifier = `merchant.com.${merchantIdentifierRoot}`;
    const promise = window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
    promise
      .then((canMakePayments: boolean) => {
        if (canMakePayments) {
          setApplePayLoaded(true);
        }
        console.log('Apple Pay loaded');
      })
      .catch((err: any) => {
        console.error('Apple Pay error:', err);
      });
  }
};
